require('./angulartics-google-analytics')
module.exports = 'angulartics.google.analytics'



/*****************
 ** WEBPACK FOOTER
 ** ./DeliveryCreate/UI/~/angulartics-google-analytics/lib/index.js
 ** module id = 213
 ** module chunks = 0
 **/